// extracted by mini-css-extract-plugin
export default {"mainView":"VrScreenTextInput_mainView__SdLEC","textInput":"VrScreenTextInput_textInput__5ldWF","error":"VrScreenTextInput_error__jG9XJ"};